module.exports = __webpack_public_path__ + "static/media/use-case-6.c496a16d.jpg";